import React, { Fragment } from 'react';
import HeaderPortal from '../../../components/layout/HeaderPortal';
import DashboardContainer from './DashboardContainer';

const Route = () => {
  return (
    <Fragment>
      <HeaderPortal />
      <DashboardContainer />
    </Fragment>
  );
};

export default Route;
